import { Box } from "@mui/joy";
import DarkTypography from "components/common/DarkTypography";
import { NO_ACCESS_MESSAGE } from "components/common/DashboardPage";

export default function PlanningAccessDenied() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
        minHeight: "50vh",
        p: 3,
      }}
    >
      <DarkTypography
        level="body-lg"
        colorVariant="muted"
        sx={{ textAlign: "center", maxWidth: 400 }}
      >
        {NO_ACCESS_MESSAGE}
      </DarkTypography>
    </Box>
  );
}
